import {
  Card,
  CircularProgress,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core';
import React from 'react';
import DownArrow from '@material-ui/icons/ArrowDropDown';
import UpArrow from '@material-ui/icons/ArrowDropUp';
import Refresh from '@material-ui/icons/Refresh';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import ActionTypes from '../../../../actions/types';
import SharkIcon from '../../../icons/shark.png';
import { useParams } from 'react-router-dom';

const OISearchForm = ({
  styles,
  refreshDataAndExpirations,
  lengthCheck,
  targetFromChange,
  targetToChange,
  handlePercent,
}) => {
  let { ticker } = useParams();
  const { appReducer } = useSelector((state) => state);
  const { quoteInfo, isMobile,  refreshingQuote } =
    appReducer;
  const {
    latestPrice,
    latestUpdate,
    from,
    to,
    percent,
    change: priceChange,
    changePercent: priceChangePercent,
  } = quoteInfo;

  const dispatch = useDispatch();
  const setStateAction = (newState) => {
    dispatch({
      type: ActionTypes.SET_OPEN_INTREST,
      payload: newState,
    });
  };
  return (
    <div style={styles.headerInfoMobile}>
      <Card
        style={{
          ...styles.selectorsMobile,
          borderRight: '1px black solid',
          width: '40%',
        }}
      >
        {!ticker && (
          <Typography
            variant="inherit"
            component="h5"
            style={{
              ...styles.noTickerText,
              fontSize: '0.75rem',
            }}
          >
            Enter a stock ticker to your left & click 'Go'
          </Typography>
        )}
        {ticker && (
          <div>
            <Typography
              variant="inherit"
              component="h3"
              style={{
                ...styles.companyText,
                fontSize: '0.9rem',
              }}
            >
              {/* {companyName && !isMobile ? companyName.substring(0, 12) : ''} */}
              {!isMobile
                ? `${ticker}`
                : `${ticker} $${(latestPrice * 1).toFixed(2)}
               `}
            </Typography>
            <div style={styles.stockPriceInfo}>
              <span
                style={
                  priceChange < 0
                    ? styles.negPriceChange
                    : styles.posPriceChange
                }
              >
                {priceChange < 0 ? (
                  <DownArrow
                    style={isMobile ? styles.downArrowMobile : styles.downArrow}
                  />
                ) : (
                  <UpArrow
                    style={isMobile ? styles.upArrowMobile : styles.upArrow}
                  />
                )}{' '}
                <span style={styles.priceChange}>
                  ${Math.abs(priceChange).toFixed(2)}
                </span>
                ({Math.abs(priceChangePercent).toFixed(2)}
                %)
              </span>

              {refreshingQuote ? (
                <CircularProgress
                  style={styles.circularSpinner}
                  size={20}
                  color="primary"
                />
              ) : (
                <IconButton
                  aria-label="Refresh"
                  disabled={refreshingQuote}
                  size="small"
                  color="primary"
                  style={styles.refreshButton}
                  onClick={() => {
                    refreshDataAndExpirations(ticker);
                  }}
                >
                  <Refresh />
                </IconButton>
              )}
            </div>
            <div style={{ display: 'flex' }}>
              <Typography
                variant="body1"
                component="div"
                style={{
                  ...styles.timestampText,
                  paddingTop: '2px',
                }}
              >
                As of {moment(latestUpdate).format('MMM DD h:mma')}
              </Typography>
              {lengthCheck ? (
                <div
                  style={{
                    height: '20px',
                    width: '20px',
                    marginLeft: '10px',
                  }}
                  onClick={() =>
                    setStateAction({
                      holderModal: true,
                    })
                  }
                >
                  <img height="100%" width="100%" src={SharkIcon} alt="" />
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        )}
      </Card>
      <Card
        style={{
          ...styles.selectorsMobile,
          width: '60%',
          paddingRight: '5px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <div
            style={{
              ...styles.selectorsFlex,
              fontSize: '12px',
            }}
          >
            From
            <TextField
              name="from"
              style={styles.inputItem}
              value={from}
              type="number"
              InputProps={{
                style: {
                  textAlign: 'center',
                  fontSize: isMobile ? 16 : 14,
                },
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
              onChange={(event) => targetFromChange(event, event.target.value)}
            />
          </div>
          <div
            style={{
              ...styles.selectorsFlex,
              fontSize: '12px',
            }}
          >
            To
            <TextField
              name="to"
              style={styles.inputItem}
              value={to}
              type="number"
              InputProps={{
                style: {
                  textAlign: 'center',
                  fontSize: isMobile ? 16 : 14,
                },
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
              onChange={(event) => targetToChange(event, event.target.value)}
            />
          </div>
        </div>
        <div>
          <FormControl component="fieldset" style={{ flex: 1 }}>
            <RadioGroup
              defaultValue="female"
              aria-label="gender"
              name="customized-radios"
              onChange={(event) => handlePercent(event, event.target.value)}
              value={percent}
              row
              style={{ justifyContent: 'space-around' }}
            >
              <div style={{ width: '30px', marginTop: '1%' }}>Top</div>
              <FormControlLabel
                value="1"
                control={
                  <Radio
                    color="primary"
                    size="small"
                    style={{ padding: '0px' }}
                  />
                }
                label="1%"
                style={{
                  fontSize: '12px',
                  marginLeft: '0px',
                }}
              />
              <FormControlLabel
                value="5"
                control={
                  <Radio
                    color="primary"
                    size="small"
                    style={{ padding: '0px' }}
                  />
                }
                label="5%"
                style={{
                  fontSize: '12px',
                  marginLeft: '3px',
                }}
              />
              <FormControlLabel
                value="10"
                control={
                  <Radio
                    color="primary"
                    size="small"
                    style={{ padding: '0px' }}
                  />
                }
                label="10%"
                style={{
                  fontSize: '12px',
                  marginRight: '0px',
                  marginLeft: '3px',
                }}
              />
            </RadioGroup>
          </FormControl>
        </div>
      </Card>
    </div>
  );
};
export default OISearchForm;



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/components/mobileViewComponents/OISearchForm.jsx